export function Apn_Normalize(raw: string): string {
  return raw.trim().replace(/[\s\-/.]/g, "");
}

/**
 * Contra Costa–style 9-digit APN with leading zeros.
 * Longer CA APNs (LA AIN, some condo pins) stay full length — never truncate.
 */
export function Apn_Canonical_9(raw: string): string {
  const Digits = Apn_Normalize(raw);
  if (!Digits) {
    return "";
  }
  if (Digits.length >= 9) {
    return Digits;
  }
  return Digits.padStart(9, "0");
}

export function Apn_Candidates_List(apnNormalized: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  const add = (value: string) => {
    const trimmed = value.trim();
    if (!trimmed || seen.has(trimmed)) return;
    seen.add(trimmed);
    out.push(trimmed);
  };
  if (/^\d+$/.test(apnNormalized)) {
    add(Apn_Canonical_9(apnNormalized));
  }
  add(apnNormalized);
  add(apnNormalized.replace(/^0+/, "") || "0");
  return out;
}

export function Apn_Is_Equivalent(parcelApn: string, targetApn: string): boolean {
  const a = Apn_Normalize(parcelApn);
  const b = Apn_Normalize(targetApn);
  if (a === b) return true;
  return (a.replace(/^0+/, "") || "0") === (b.replace(/^0+/, "") || "0");
}

/** Filesystem / job slug — keep full digit APN (condo / LA can exceed 9). */
export function Apn_Slug(apn: string): string {
  return apn.replace(/\D/g, "").slice(0, 20) || "unknown";
}

export function Apn_Where_Value_Escape(value: string): string {
  return value.replace(/'/g, "''");
}
